import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserListComponent } from './auth/user/user-list/user-list.component';
import { AuthGuard } from './auth/service/auth/auth.guard';


import { LoginComponent } from './auth/login/login.component';
import { ProjectListComponent } from './auth/projects/project-list/project-list.component';
import { ProjectFormComponent } from './auth/projects/project-form/project-form.component';
import { UserFormComponent } from './auth/user/user-form/user-form.component';
import { RoleListComponent } from './auth/roles/role-list/role-list.component';
import { RoleFormComponent } from './auth/roles/role-form/role-form.component';
import { MicroServiceListComponent } from './auth/micro-service/micro-service-list/micro-service-list.component';
import { MicroServiceFormComponent } from './auth/micro-service/micro-service-form/micro-service-form.component';



const routes: Routes = [
  { path: "", component: UserListComponent, canActivate: [AuthGuard] },
  { path: "project-roles/:projectId/roles", component: RoleListComponent, canActivate: [AuthGuard] },


  { path: 'project-roles/:projectId/create-role', component: RoleFormComponent },
  { path: "project-roles/:projectId/role-details/:id", component: RoleFormComponent, canActivate: [AuthGuard] },
  { path: "project-roles/:projectId/role-edit/:id", component: RoleFormComponent, canActivate: [AuthGuard] },
  { path: 'project-roles/:projectId', component: RoleListComponent },


  { path: "project-users/:projectId/users", component: UserListComponent, canActivate: [AuthGuard] },
  { path: "project-users/:projectId/create-user", component: UserFormComponent, canActivate: [AuthGuard] },
  { path: "project-users/:projectId/user-details/:id", component: UserFormComponent, canActivate: [AuthGuard] },
  { path: "project-users/:projectId/user-edit/:id", component: UserFormComponent, canActivate: [AuthGuard] },
  { path: "project-users/:projectId", component: UserListComponent },


  { path: "microservices", component: MicroServiceListComponent, canActivate: [AuthGuard] },
  { path: "microservices/:id", component: MicroServiceFormComponent, canActivate: [AuthGuard] },




  { path: "projects", component: ProjectListComponent, canActivate: [AuthGuard] },
  { path: "create-project", component: ProjectFormComponent, canActivate: [AuthGuard] },
  { path: "project-details/:id", component: ProjectFormComponent, canActivate: [AuthGuard] },
  { path: "project-edit/:id", component: ProjectFormComponent, canActivate: [AuthGuard] },

  { path: "login", component: LoginComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
